<template>
  <div id="tut-table-results">
    <div class="table-responsive full_table mt-0">
      <table class="table caption-top">
        <thead class="bg_table_header">
          <tr>
            <th v-if="!byInstitucional" class="col-md-1 py-3">ID<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(4)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-4)"></button></th>
            <th class="col-md-2 py-3 pl-4">{{ $t('label.reino') }}<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(1)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-1)"></button></th>
            <th class="col-md-2 py-3 pl-4">{{ $t('label.familia') }}<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(2)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-2)"></button></th>
            <th class="col-md-4 py-3 pl-4">{{ $t('label.nomeCientifico') }}<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(3)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-3)"></button></th>
            <th class="col-md-4 py-3 pl-4" v-if="byInstitucional">{{ $t('label.nomeComum') }}</th>
            <th class="col-md-4 py-3 pl-2 pr-4 text-right">{{ byInstitucional ? $t('label.verDados') : $t('label.acoes') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="$store.state.countList === 0"><td :colspan="byInstitucional ? 6 : 5" class="text-center">{{ $t('message.noRecords') }}</td></tr>
          <tr v-else v-for="item in items" :key="item.species_id">
            <td v-if="!byInstitucional" class="py-3">{{item.species_id}}</td>
            <td class="py-3 pl-4">{{item.kingdom}}</td>
            <td class="py-3 pl-4">{{item.family}}</td>
            <td class="py-4 pl-4">{{item.scientific_name}}</td>
            <td class="py-4 pl-4" v-if="byInstitucional">{{item.common_name}}</td>
            <td class="py-2 pl-2">
              <ul class="acoes text-right pr-1">
                <template v-if="byInstitucional">
                  <li>
                    <a @click="actionByInstitucional(item)"><span class="visualizar"></span></a>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <a @click="action($actionEdit, item)" v-if="item.pending_analysis"><span class="nao-validado"></span></a>
                    <a @click="action($actionEdit, item)" v-else><span class="validar"></span></a>
                  </li>
                  <li>
                    <a @click="action($actionEdit, item)"><span class="editar"></span></a>
                  </li>
                  <li>
                    <a @click="action($actionDelete, item)" v-if="$store.state.user && $store.state.user.perfilUser === 'administrator'"><span class="apagar"></span></a>
                  </li>
                </template>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination v-on:searchTable="search()"/>
  </div>
</template>

<script>
import TablePagination from '@/components/shared/TablePagination'
import axios from 'axios'
export default {
  name: 'EspeciesTable',
  components: { TablePagination },
  props: {
    items: Array,
    byInstitucional: {
      type: Boolean,
      default: false
    },
    withOrderBy: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      dataOrderBy: {}
    }
  },
  methods: {
    search: function () {
      this.$emit('search')
    },
    actionByInstitucional: function (item) {
      this.$emit('actionByInstitucional', item)
    },
    action: function (action, item) {
      if (action === this.$actionDelete) {
        if (confirm(this.$t('message.confirmDelEspecie'))) {
          this.delete(item)
        }
      } else {
        if (this.$route.name === 'AdminHome') {
          this.$store.state.dashboard.currentPage = this.$store.state.currentPage
        }
        this.$store.state.currentPageSpecie = this.$store.state.currentPage
        this.$router.push({ name: 'AdminEspeciesForm', params: { id: item.species_id } })
      }
    },
    delete: function (item) {
      axios.delete(`/Specie/${item.species_id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.search()
        })
    },
    orderBy: function (num) {
      if (num === 1) {
        this.$store.state.dataOrderBy.OrderByKingdomAcs = true
        this.$store.state.dataOrderBy.OrderByKingdomDesc = !this.$store.state.dataOrderBy.OrderByKingdomAcs
      }
      if (num === -1) {
        this.$store.state.dataOrderBy.OrderByKingdomDesc = true
        this.$store.state.dataOrderBy.OrderByKingdomAcs = !this.$store.state.dataOrderBy.OrderByKingdomDesc
      }
      if (num === 2) {
        this.$store.state.dataOrderBy.OrderByFamilyAcs = true
        this.$store.state.dataOrderBy.OrderByFamilyDesc = !this.$store.state.dataOrderBy.OrderByFamilyAcs
      }
      if (num === -2) {
        this.$store.state.dataOrderBy.OrderByFamilyDesc = true
        this.$store.state.dataOrderBy.OrderByFamilyAcs = !this.$store.state.dataOrderBy.OrderByFamilyDesc
      }
      if (num === 3) {
        this.$store.state.dataOrderBy.OrderByScientificNameAcs = true
        this.$store.state.dataOrderBy.OrderByScientificNameDesc = !this.$store.state.dataOrderBy.OrderByScientificNameAcs
      }
      if (num === -3) {
        this.$store.state.dataOrderBy.OrderByScientificNameDesc = true
        this.$store.state.dataOrderBy.OrderByScientificNameAcs = !this.$store.state.dataOrderBy.OrderByScientificNameDesc
      }
      if (num === 4) {
        this.$store.state.dataOrderBy.OrderByIDAcs = true
        this.$store.state.dataOrderBy.OrderByIDDesc = !this.$store.state.dataOrderBy.OrderByIDAcs
      }
      if (num === -4) {
        this.$store.state.dataOrderBy.OrderByIDDesc = true
        this.$store.state.dataOrderBy.OrderByIDAcs = !this.$store.state.dataOrderBy.OrderByIDDesc
      }
      this.$emit('orderBy', this.$store.state.dataOrderBy)
    }
  }
}
</script>
